/**
 * The resize mode last asked of `@capacitor/keyboard` on iOS. Under `native` the plugin shrinks the WebView
 * around the keyboard (after the keyboard finishes animating), so nothing in the page should lift for it as
 * well; under `none` (phone chat, the auth screen) the WebView stays full height and the page makes room
 * itself. `keyboard.ts` reads this to decide whether a native keyboard is an inset at all.
 *
 * Every `Keyboard.setResizeMode` call site records the mode here, synchronously, before the plugin call: the
 * plugin reads its mode when its delayed frame update runs, so the last request is what will happen.
 */
import { ref } from 'vue'

export type NativeResizeMode = 'native' | 'none'

/** `native` matches the shipped capacitor.config (`Keyboard.resize: 'native'`). */
export const nativeResizeMode = ref<NativeResizeMode>('native')

export function noteNativeResizeMode(mode: NativeResizeMode): void {
    nativeResizeMode.value = mode
}
